module.exports = __webpack_public_path__ + "static/media/cpl.0c3bc5fe.png";